import React, { FC } from 'react';
import { Box, BoxProps } from '@mui/material';
import { useLayoutContext } from './LayoutContext';

export interface ContentProps extends BoxProps {}

const Content: FC<ContentProps> = ({ children }) => {
  const {
    layoutState: { sidebarOpen },
  } = useLayoutContext();

  return (
    <Box
      sx={theme => ({
        boxSizing: 'border-box',
        maxWidth: '100vw',
        minHeight: '100vh',
        [theme.breakpoints.up('laptop')]: {
          paddingLeft: `var(--sidebar-width)`,
          transition: theme.transitions.create('padding', {
            easing: theme.transitions.easing.sharp,
            duration: sidebarOpen
              ? theme.transitions.duration.leavingScreen
              : theme.transitions.duration.enteringScreen,
          }),
        },
      })}
    >
      {children}
    </Box>
  );
};

export default Content;
